export function createPdfAddendumNode(doc: XMLDocument, fileName: string): HTMLElement {
  const form = doc.createElement('Form');
  form.setAttribute('Id', 'PDFAddendum');

  const fields = doc.createElement('Fields');
  form.append(fields);

  const pdfField = doc.createElement('PdfField');
  pdfField.setAttribute('Id', 'Pdf');
  pdfField.setAttribute('Data', fileName);
  fields.append(pdfField);

  return form;
}
